import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  shippingLabelModalAsyncActions,
  shippingLabelModalSelectors,
} from '@/ModalWindows/ShippingLabelModal/services';
import { shippingLabelModalUtils } from '@/ModalWindows/ShippingLabelModal/services/utils';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { salesPageSelectors } from '@/Pages/Sales/services';
import { purchasesPageSelectors } from '@/Pages/Purchases/services';

export const useSelectWarehouseOptions = (isSales: boolean) => {
  const dispatch: AppDispatch = useDispatch();

  const selectedOrderIds = useSelector(
    isSales ? salesPageSelectors.selectedSalesIds : purchasesPageSelectors.selectedPurchasesIds,
  );

  const orderWarehouseInfos = useSelector(shippingLabelModalSelectors.orderWarehouseInfos);

  useEffect(() => {
    dispatch(
      shippingLabelModalAsyncActions.getOrdersWarehouseInfo({
        orderIds: selectedOrderIds,
      }),
    );
  }, []);

  const warehouseOptions = useMemo(() => {
    return shippingLabelModalUtils.getWarehouseOptions(orderWarehouseInfos);
  }, [orderWarehouseInfos]);

  return {
    orderWarehouseInfos,
    warehouseOptions,
  };
};
